import React from "react";
import { primary, secondary } from "./variants";
import { Button as ChakraButton } from "@chakra-ui/core";
import { darken } from "polished";

const variants = {
    primary,
    secondary,
};

export const Button = (props) => {
    const {
        children,
        variant = "primary",
        variantStyle = "solid",
        isDark,
        isDisabled,
        bold,
        underline,
        italic,
        uppercase,
        strikethrough,
        ...restProps
    } = props;
    const textStyles = {
        ...(bold && { fontWeight: "bold" }),
        ...(underline && { textDecoration: "underline" }),
        ...(strikethrough && { textDecoration: "line-through" }),
        ...(italic && { fontStyle: "italic" }),
    };

    return (
        <ChakraButton
            variant={variantStyle}
            color={variants[variant].textColor}
            fontFamily={`body`}
            isDisabled={isDisabled}
            {...textStyles}
            {...{
                ...variants[variant][`sharedProps`],
                ...(variantStyle === `solid` && {
                    bg: variants[variant].accentColor,
                    ...variants[variant].solidProps,
                }),
                ...(variantStyle === `outline` && {
                    borderColor: variants[variant].accentColor,
                    borderWidth: "2px",
                    ...variants[variant].outlineProps,
                }),
                ...(variantStyle === `ghost` && {
                    ...variants[variant].ghostProps,
                }),
                ...(variantStyle === `link` && {
                    padding: "",
                    ...{
                        ...(isDisabled && {
                            _hover: { textDecoration: `none` },
                        }),
                    },
                    _active: {
                        color: darken(0.05, variants[variant].textColor),
                    },
                    ...variants[variant].linkProps,
                }),
                ...restProps,
            }}
        >
            {children}
        </ChakraButton>
    );
};

Button.defaultProps = {
    isDark: false,
    isDisabled: false,
    variant: "primary",
    variantStyle: "solid",
};
